import CarNumber from "components/CarNumber";
import React from "react";
import { Popup, Table } from "semantic-ui-react";
const ControlPointsCell = ({
  date,
  time1,
  time2,
  carNumber,
  crashes,
  crashReason,
  intl,
  ...props
}) => {
  return crashes && crashes.length > 0 ? (
    <Popup
      trigger={
        <Table.Cell className="bg-red" {...props}>
          <div className="control-points-cell">
            <div className="control-points-column flex-o">
              <div className="time-data">{date}</div>
              <div className="time-data">{time1}</div>
              <div className="time-data">{time2}</div>
            </div>
            <div className="control-points-column">
              <CarNumber number={carNumber} />
            </div>
          </div>
        </Table.Cell>
      }
      content={renderCrashes(crashes, intl)}
      inverted
      position="top center"
      mouseEnterDelay={600}
      flowing
    />
  ) : (
    <Table.Cell {...props}>
      <div className="control-points-cell">
        <div className="control-points-column flex-o">
          <div className="time-data">{date}</div>
          <div className="time-data">{time1}</div>
          <div className="time-data">{time2}</div>
        </div>
        <div className="control-points-column">
          <CarNumber number={carNumber} />
        </div>
      </div>
    </Table.Cell>
  );
};

const renderCrashes = (crashes, intl) => {
  return (
    <div>
      {crashes.map((crash) => (
        <div key={crash.crashId}>
          {intl.formatMessage({ id: `reason.${crash.crashReason}` })}
        </div>
      ))}
    </div>
  );
};

export default ControlPointsCell;
